// Get the modal and buttons
var modal = document.getElementById("waitlist-modal");
var span = document.getElementsByClassName("close")[0];

// Close the modal if the user clicks outside of it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}

function filterTourDates() {
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById('tour-search');
    filter = input.value.toUpperCase();
    table = document.querySelector('table.tour-dates');
    tr = table.getElementsByTagName('tr');

    for (i = 1; i < tr.length; i++) {
        td = tr[i].getElementsByTagName('td');
        let matchFound = false;
        for (let j = 0; j < td.length; j++) {
            if (td[j]) {
                txtValue = td[j].textContent || td[j].innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    matchFound = true;
                    break;
                }
            }
        }
        tr[i].style.display = matchFound ? "" : "none";
    }
}

function clearSearch() {
    document.getElementById('tour-search').value = '';
    filterTourDates();
}

function showWaitlistForm(tourDetails) {
    document.getElementById("tour-details").textContent = "Join the waitlist for: " + tourDetails;
    document.getElementById("waitlist-form").style.display = "block";
}

function closeWaitlistForm() {
    document.getElementById("waitlist-form").style.display = "none";
}

function submitWaitlist() {
    var name = document.getElementById("name").value;
    if (name) {
        alert(name + ", you've successfully joined the waitlist!");
        closeWaitlistForm();
    } else {
        alert("Please enter your name.");
    }
}

// Function to check if the cookies have been accepted
function checkCookieBanner() {
	const cookieBanner = document.getElementById('cookie-banner');
	const cookieAccepted = localStorage.getItem('cookiesAccepted');

	if (!cookieAccepted) {
		cookieBanner.classList.remove('hidden');
	}
}

// Function to hide the banner and set cookies as accepted
function acceptCookies() {
	localStorage.setItem('cookiesAccepted', true);
	const cookieBanner = document.getElementById('cookie-banner');
	cookieBanner.classList.add('hidden');
}

// Function to show the cookie preferences pane
function showCookiePreferences() {
	const preferencesPane = document.getElementById('cookie-preferences');
	preferencesPane.classList.remove('hidden');
}

// Function to hide the cookie preferences pane
function hideCookiePreferences() {
	const preferencesPane = document.getElementById('cookie-preferences');
	preferencesPane.classList.add('hidden');
}

function showVideoPlayer() {
	const videoPlayerFrame = document.getElementById('video-player-frame');
	if (videoPlayerFrame) {
		videoPlayerFrame.classList.remove('hidden');
	}
}

function hideVideoPlayer() {
	const videoPlayerFrame = document.getElementById('video-player-frame');
	const videoIframe = document.getElementById('video-iframe');

	if (videoPlayerFrame) {
		videoPlayerFrame.classList.add('hidden');
	}

	if (videoIframe) {
		// Reset the src to stop the video
		videoIframe.src = videoIframe.src;
	}
}

// Function to update label text based on input value
function updateLabelText() {
	const emailInput = document.getElementById('email');
	const countrySelect = document.getElementById('country');
	const requiredNote = document.querySelector('.required-note'); // Get the required note element

	// Update email label
	const emailLabel = document.querySelector('label[for="email"]');
	if (emailInput.value) {
		emailLabel.textContent = 'EMAIL';
	} else {
		emailLabel.textContent = '* EMAIL';
	}

	// Update country label
	const countryLabel = document.querySelector('label[for="country"]');
	if (countrySelect.value) {
		countryLabel.textContent = 'COUNTRY';
	} else {
		countryLabel.textContent = '* CHOOSE COUNTRY';
	}

	// Check if both fields are selected and hide the required note
	if (emailInput.value && countrySelect.value) {
		if (requiredNote) {
			requiredNote.style.display = 'none'; // Hide the required note
		}
	} else {
		if (requiredNote) {
			requiredNote.style.display = 'block'; // Show the required note if not both fields are filled
		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
	checkCookieBanner();
	const hamburger = document.getElementById("hamburger");
	const drawer = document.querySelector(".drawer");
	const body = document.body;

	if (hamburger && drawer) {
		hamburger.addEventListener("click", () => {
			hamburger.classList.toggle("active");
			drawer.classList.toggle("open");
			body.classList.toggle("no-scroll");
		});

		// Close drawer when clicking a link
		drawer.addEventListener("click", (event) => {
			if (event.target.tagName === "A") {
				hamburger.classList.remove("active");
				drawer.classList.remove("open");
				body.classList.remove("no-scroll");
			}
		});
	}

	document.querySelectorAll('.navigation a').forEach(anchor => {
		anchor.addEventListener('click', () => {
			hamburger.classList.remove('active');
			navigation.classList.remove('active');
			console.log('Navigation link clicked');
		});
	});

	const controls = {
		albums: {
			items: document.querySelectorAll('.music-release'),
			nextButton: document.getElementById('music-next'),
			backButton: document.getElementById('music-back'),
			pageNav: document.querySelector('.music-page-nav'),
			pageIndicator: document.querySelector('.music-page-indicator'),
			perPage: {
				mobile: 1,
				tablet: 10,
				desktop: 10
			},
		},
		videos: {
			items: document.querySelectorAll('.thumbnail'),
			nextButton: document.getElementById('video-next'),
			backButton: document.getElementById('video-back'),
			pageNav: document.querySelector('.video-page-nav'),
			pageIndicator: document.querySelector('.video-page-indicator'),
			perPage: {
				mobile: 1,
				tablet: 3,
				desktop: 4
			},
		},
	};

	const state = {
		albums: {
			currentPage: 1,
			itemsPerPage: 1,
			items: Array.from(document.querySelectorAll('.music-release'))
		},
		videos: {
			currentPage: 1,
			itemsPerPage: 1,
			items: Array.from(document.querySelectorAll('.thumbnail'))
		},
	};

	const updateItemsPerPage = (key) => {
		const screenWidth = window.innerWidth;
		console.log('Screen width:', screenWidth);
		const config = controls[key].perPage;

		if (screenWidth >= 960) {
			state[key].itemsPerPage = config.desktop;
		} else if (screenWidth >= 720) {
			state[key].itemsPerPage = config.tablet;
		} else {
			state[key].itemsPerPage = config.mobile;
		}
	};

	const displayCurrentPage = (key) => {
		const {
			itemsPerPage,
			currentPage
		} = state[key];
		const {
			items,
			pageIndicator,
			nextButton,
			backButton,
			pageNav
		} = controls[key];

		// Calculate total pages
		const totalPages = Math.ceil(items.length / itemsPerPage);
		console.log(`${key} total pages:`, totalPages); // Debugging: Check total pages calculation

		// Display or hide items based on the current page
		const startIndex = (currentPage - 1) * itemsPerPage;
		const endIndex = startIndex + itemsPerPage;

		items.forEach((item, index) => {
			if (index >= startIndex && index < endIndex) {
				item.classList.remove('hidden');
			} else {
				item.classList.add('hidden');
			}
		});

		// Handle visibility of the page-nav for this context
		if (pageNav) {
			if (totalPages <= 1) {
				pageNav.style.display = 'none'; // Hide if only 1 page exists
			} else {
				pageNav.style.display = 'flex'; // Show for multiple pages
			}
		}

		// Adjust opacity of navigation buttons
		if (backButton && nextButton) {
			if (currentPage === 1) {
				backButton.style.opacity = '0.5'; // Disable back button
				nextButton.style.opacity = totalPages > 1 ? '1' : '0.5'; // Enable or disable next button
			} else if (currentPage === totalPages) {
				backButton.style.opacity = '1'; // Enable back button
				nextButton.style.opacity = '0.5'; // Disable next button
			} else {
				backButton.style.opacity = '1'; // Enable both buttons
				nextButton.style.opacity = '1';
			}
		}

		// Update page indicator
		if (pageIndicator) {
			pageIndicator.textContent = `${currentPage}/${totalPages}`;
		}
	};

	const goToNextPage = (key) => {
		const {
			items,
			itemsPerPage,
			currentPage
		} = state[key];

		// Check if items are available before accessing length
		if (!items || items.length === 0) {
			console.error(`No items found for ${key}`);
			return; // Exit if no items are available
		}

		const totalPages = Math.ceil(items.length / itemsPerPage);

		if (currentPage < totalPages) {
			state[key].currentPage++;
			displayCurrentPage(key);
		}
	};

	const goToPreviousPage = (key) => {
		const {
			items
		} = state[key];

		// Check if items are available before accessing length
		if (!items || items.length === 0) {
			console.error(`No items found for ${key}`);
			return; // Exit if no items are available
		}

		if (state[key].currentPage > 1) {
			state[key].currentPage--;
			displayCurrentPage(key);
		}
	};

	const handleResize = () => {
		Object.keys(controls).forEach((key) => {
			const previousItemsPerPage = state[key].itemsPerPage;
			updateItemsPerPage(key);

			if (state[key].itemsPerPage !== previousItemsPerPage) {
				state[key].currentPage = 1;
			}

			displayCurrentPage(key);
		});
	};

	Object.keys(controls).forEach((key) => {
		const {
			nextButton,
			backButton
		} = controls[key];
		if (nextButton) {
			nextButton.addEventListener('click', () => goToNextPage(key));
		}
		if (backButton) {
			backButton.addEventListener('click', () => goToPreviousPage(key));
		}
	});

	window.addEventListener('resize', handleResize);
	Object.keys(controls).forEach((key) => {
		updateItemsPerPage(key);
		displayCurrentPage(key);
	});
});

// Add event listeners to the fields to update the labels on input
document.getElementById('email').addEventListener('input', updateLabelText);
document.getElementById('country').addEventListener('change', updateLabelText);

// Run the function initially to set correct label text on page load
updateLabelText();

// Event listeners
document.querySelector('.cookie-button').addEventListener('click', acceptCookies);
document.getElementById('manage-preferences').addEventListener('click', showCookiePreferences);
document.getElementById('close-preferences').addEventListener('click', hideCookiePreferences);

document.getElementById('newsletter-form').addEventListener('submit', function(event) {
	event.preventDefault(); // Prevent default form submission

	// Get form data
	const email = document.getElementById('email').value;
	const country = document.getElementById('country').value;

	// Validate email
	if (!email || !country) {
		alert("Please fill out both fields.");
		return;
	}

	// Form data to send
	const formData = {
		email: email,
		country: country
	};

	// Send data via fetch to the server (or third-party service)
	fetch('/submit-newsletter', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
		.then(response => response.json())
		.then(data => {
			// Handle successful submission
			document.getElementById('newsletter-feedback').innerText = 'Thank you for subscribing!';
		})
		.catch(error => {
			// Handle errors
			document.getElementById('newsletter-feedback').innerText = 'There was an error. Please try again later.';
		});
});